import * as React from 'react';

function SvgAddCommentsFill(props) {
  return (
    <svg width={22} height={22} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <rect fill="#38B2A6" width={22} height={22} rx={11} />
        <g fill="#FFF" fillRule="nonzero">
          <path d="M15.728 5.85l-.663-.663a.66.66 0 00-.932.012l-.995.995H6.884A.886.886 0 006 7.08v8.597c0 .487.397.884.884.884h6.963a.886.886 0 00.885-.884v-7.91l.984-.984a.66.66 0 00.012-.932zm-1.587 9.826a.296.296 0 01-.295.295H6.884a.296.296 0 01-.295-.295V7.079c0-.162.132-.296.295-.296h5.663l-1.812 1.814a.668.668 0 00-.198.462l-.016.657a.638.638 0 00.643.66h.016l.7-.017a.674.674 0 00.497-.238l1.764-1.764v7.319zm1.126-9.344l-3.349 3.35-.011.01-.011.013c-.006.008-.018.017-.03.017l-.7.016-.008-.001s-.002-.002-.002-.008l.016-.658c0-.012.01-.022.013-.027l3.398-3.398c.01-.01.02-.012.027-.012l.006.001.662.662c.002.004.005.021-.011.035z" />
          <path d="M7.623 11.72c0 .175.143.318.317.318h5.018a.319.319 0 00.318-.318.319.319 0 00-.318-.318H7.94a.316.316 0 00-.317.318zm3.05 1.56H7.94a.319.319 0 00-.317.319c0 .174.143.317.317.317h2.735a.319.319 0 00.317-.317.319.319 0 00-.319-.318z" />
        </g>
      </g>
    </svg>
  );
}

export default SvgAddCommentsFill;
